import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";

export default function ReservaExito() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [reservation, setReservation] = useState(null);

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const r = await axios.get(`/api/checkout/status/${sid}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid"); setReservation(r.data.reservation); return;
        }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        if (attempts < 10) setTimeout(poll, 2000); else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sid]);

  return (
    <section className="section-light py-16" data-testid="reserva-exito">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center">
        {status === "checking" && <div><h1 className="font-display text-3xl mb-3">{t("reservaExito.comprobandoPago")}</h1><p className="text-neutral-600">{t("reservaExito.unSegundo")}</p></div>}
        {status === "paid" && reservation && (
          <div>
            <div className="text-6xl mb-4">🏁</div>
            <h1 className="font-display text-4xl mb-3 text-[var(--pc-red)]">{t("reservaExito.reservaConfirmada")}</h1>
            <p className="text-neutral-700 mb-6">{t("reservaExito.contratoEnviado", { email: reservation.customer.email })}</p>
            <div className="bg-[var(--pc-grey)] rounded-lg p-5 text-left text-sm space-y-1 mb-6">
              <div><strong>{t("reservaExito.reserva")}:</strong> {reservation.id}</div>
              <div><strong>{t("reservaExito.coche")}:</strong> {reservation.vehicle_name}</div>
              <div><strong>{t("reservaExito.recogida")}:</strong> {reservation.fecha_recogida}</div>
              <div><strong>{t("reservaExito.devolucion")}:</strong> {reservation.fecha_devolucion}</div>
              <div><strong>{t("reservaExito.totalPagado")}:</strong> {reservation.total.toFixed(2)} €</div>
            </div>
            <a href={`${process.env.REACT_APP_BACKEND_URL}/api/reservations/${reservation.id}/contract.pdf?session_id=${encodeURIComponent(sid)}`} className="btn-red px-6 py-3" data-testid="download-contract">{t("reservaExito.descargarContrato")}</a>          </div>
        )}
        {(status === "error" || status === "expired" || status === "timeout") && (
          <div>
            <h1 className="font-display text-3xl mb-3">{t("reservaExito.noConfirmamos")}</h1>
            <Link to="/vehiculos" className="btn-red inline-block px-6 py-3 mt-4">{t("reservaExito.volverEmpezar")}</Link>
          </div>
        )}
      </div>
    </section>
  );
}
